import updateFileMeta from '@picsart/cloud-storage/api/updateFileMeta';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  id: string;
  name: string;
};

const changeDriveFileName = async ({ id, name }: Params) => {
  return withCloudStorageErrorHandling({
    operation: async () => {
      await updateFileMeta({
        fileId: id,
        name,
        headers: getCloudStorageHeaders(),
      });
      return true;
    },
    errorMessage: ErrorMessages.changeFileName,
  });
};

export { changeDriveFileName };
